/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  MultiBankSubProductRequest,
  MultiBankSubProductResponse,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const createMultibankSubProduct = (
  multiBankSubProductRequest: MultiBankSubProductRequest
) => {
  return customInstance<string>({
    url: `/operations/own/multibank/subproduct`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: multiBankSubProductRequest,
  });
};

export const getCreateMultibankSubProductMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMultibankSubProduct>>,
    TError,
    { data: MultiBankSubProductRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMultibankSubProduct>>,
  TError,
  { data: MultiBankSubProductRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMultibankSubProduct>>,
    { data: MultiBankSubProductRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createMultibankSubProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMultibankSubProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMultibankSubProduct>>
>;
export type CreateMultibankSubProductMutationBody = MultiBankSubProductRequest;
export type CreateMultibankSubProductMutationError = unknown;

export const useCreateMultibankSubProduct = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMultibankSubProduct>>,
    TError,
    { data: MultiBankSubProductRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMultibankSubProduct>>,
  TError,
  { data: MultiBankSubProductRequest },
  TContext
> => {
  const mutationOptions = getCreateMultibankSubProductMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getMultibankSubProduct = (
  subProductUid: string,
  signal?: AbortSignal
) => {
  return customInstance<MultiBankSubProductResponse>({
    url: `/operations/own/multibank/subproduct/${subProductUid}`,
    method: 'GET',
    signal,
  });
};

export const getGetMultibankSubProductQueryKey = (subProductUid: string) => {
  return [`/operations/own/multibank/subproduct/${subProductUid}`] as const;
};

export const getGetMultibankSubProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getMultibankSubProduct>>,
  TError = unknown
>(
  subProductUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMultibankSubProduct>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMultibankSubProductQueryKey(subProductUid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMultibankSubProduct>>
  > = ({ signal }) => getMultibankSubProduct(subProductUid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!subProductUid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMultibankSubProduct>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMultibankSubProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMultibankSubProduct>>
>;
export type GetMultibankSubProductQueryError = unknown;

export const useGetMultibankSubProduct = <
  TData = Awaited<ReturnType<typeof getMultibankSubProduct>>,
  TError = unknown
>(
  subProductUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMultibankSubProduct>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMultibankSubProductQueryOptions(
    subProductUid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
